"use strict";

exports.__esModule = true;
exports.DeviceTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DeviceTableElement = require("./DeviceTableElement");
var _DeviceTableFields = require("./DeviceTableFields");
var _DeviceTableHeader = require("./DeviceTableHeader");
var _DeviceTableThumbnail = require("./DeviceTableThumbnail");
var _EditableDeviceTableElement = require("./EditableDeviceTableElement");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceTableWidget = exports.DeviceTableWidget = {
  name: "DeviceTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DeviceTableWidget.label",
    defaultMessage: "Device Table"
  }),
  group: _widgetGroups.LAYOUT_WIDGET,
  icon: "th",
  createElement: function createElement(props) {
    return {
      type: "DeviceTable",
      props: Object.assign({
        width: 800,
        height: 600
      }, props),
      children: [{
        type: "DeviceProperty",
        props: {
          propertyName: "name"
        },
        children: []
      }, {
        type: "StripeChart",
        props: {
          hideXAxis: true
        },
        children: []
      }]
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: ["device"],
  optionalProps: ["rowGutter", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 800,
      min: 32,
      max: 3840
    },
    height: {
      "default": 600,
      min: 32,
      max: 2160
    }
  },
  components: {
    Editable: _EditableDeviceTableElement.EditableDeviceTableElement,
    Header: _DeviceTableHeader.DeviceTableHeader,
    Element: _DeviceTableElement.DeviceTableElement,
    Fields: _DeviceTableFields.DeviceTableFields,
    Thumbnail: _DeviceTableThumbnail.DeviceTableThumbnail
  }
};